module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iJAy3"))).then(() => parcelRequire('cvs7o'));